import * as TYPE from './actionType.js';

export function checkinData(checkinData) {
  return { type: TYPE.CHECKINDATA, data: checkinData };
}
